var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waveWrapper "},[_c('svg',{attrs:{"width":"100%","height":"200","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"wave",attrs:{"d":"","fill":"#92411D"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }